import { paymentLinksTranslations } from "./payment-links-pt-br";

export const paymentLinks_EN_US: paymentLinksTranslations = {
	title: "Payment links",
	description: "Create and track standalone charges for the place.",
	searchPlaceholder: "Search by ID or description",
	filters: {
		status: "Status",
		dateStart: "Start date",
		dateEnd: "End date",
		dateField: "Filter date by",
		dateFieldOptions: {
			createdAt: "Creation",
			paidAt: "Payment",
		},
	},
	createButton: "New charge",
	empty: "No payment links created",
	emptyDescription: "Create a new charge to generate a payment link.",
	copyLink: "Copy link",
	open: "Open",
	linkCopied: "Link copied to clipboard",
	perPage: "page",
	columns: {
		id: "Link ID",
		description: "Description",
		amount: "Amount",
		installments: "Max. installments",
		status: "Status",
		createdAt: "Created at",
		paidAt: "Paid at",
		actions: "Actions",
	},
	status: {
		PENDING: "Pending",
		PAID: "Paid",
		EXPIRED: "Expired",
		CANCELED: "Canceled",
	},
	modal: {
		title: "New charge",
		amount: "Charge amount",
		amountPlaceholder: "$ 0.00",
		installments: "Maximum number of installments",
		paymentOrigin: "Settlement account",
		description: "Description",
		descriptionPlaceholder: "Describe the charge the payer will see",
		cancel: "Cancel",
		submit: "Generate payment link",
		successMessage: "Payment link created successfully",
		requiredField: "Required field",
		generatedTitle: "Payment link generated",
		generatedDescription: "Copy and send the link to the payer.",
		copyLink: "Copy link",
		linkCopied: "Link copied to clipboard",
		done: "Done",
	},
};
